// Frontend mirror of backend/src/helpers/cohort.js (F-029). Keep in lockstep:
// identical logic so the cohort key/label match what the server writes to CSV.
// cohort_year (calendar year) is DISTINCT from grant_year (program year 1–3).
//
// The cohort lens that once read these (a header control persisted in
// localStorage) retired on 2026-09-18; Country · Cohort year · Cycle are URL
// filters per page now — `hooks/useCohortFilters.ts`.

export interface ProgramTags {
  country?: 'US' | 'CA' | null;
  cohort_year?: number | null;
  cycle?: 'I' | 'II' | null;
  grant_year?: 1 | 2 | 3 | null;
  lifecycle?: 'active' | 'alumni' | 'pth' | null;
}

// Mirror of backend/src/helpers/cohort.js. TRF (the Tyler Robinson Foundation)
// was founded in 2013, so cohort years floor there; 2100 is a sanity ceiling.
export const COHORT_MIN_YEAR = 2013;
export const COHORT_MAX_YEAR = 2100;

const has = (v: unknown): boolean => v != null && v !== '';

export function cohortKey(program?: ProgramTags | null): string {
  const { country, cohort_year, cycle } = program || {};
  const parts = [country, cohort_year, cycle].filter(has);
  return parts.length ? parts.join('-') : 'unassigned';
}

export function cohortLabel(program?: ProgramTags | null): string {
  const { country, cohort_year, cycle } = program || {};
  if (!has(country) && !has(cohort_year) && !has(cycle)) return 'Unassigned';
  const c = has(country) ? country : '—';
  const y = has(cohort_year) ? cohort_year : '—';
  const r = has(cycle) ? `Cycle ${cycle}` : 'Cycle not set';
  return `${c} · ${y} · ${r}`;
}
